<template>
  <el-dialog class="demand_model_dialog" top="5vh" center :title="newTitle" width="80%" :before-close="handleClose"
             :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <el-form-item label="任务标题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="form.title" autocomplete="off" :disabled="isProjectDisabled">
        </el-input>
      </el-form-item>
      <el-form-item label="任务内容"  prop="context" :label-width="formLabelWidth" >
        <Editor v-if="!loading.dialog"  :content="form.context" @contentData="changeContent"
                :dialogVisibleModelType="isUpdata ? 'update' : 'create'" />
      </el-form-item>
      <div style="display:flex;">
        <el-form-item label="项目体系" prop="projectSystemId" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled" v-model="form.projectSystemId"
                     collapse-tags filterable placeholder="请选择项目体系">
            <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型" prop="type" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled"  v-model="form.type"
                     collapse-tags filterable placeholder="请选择任务类型">
            <el-option v-for="(key, value) in NEWOTHERTYPE" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求人" prop="demanderId" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off" :disabled="isProjectDisabled" v-model="form.demanderId" collapse-tags
                     filterable placeholder="请选择需求人">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="优先级" prop="priority" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled" v-model="form.priority" filterable placeholder="请选择优先级">
            <el-option v-for="(key, value) in allSelect.TEXTPRIORITY" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人" prop="ownerId" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off" :disabled="isProjectDisabled" v-model="form.ownerId" filterable
                     placeholder="请选择负责人">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预估工时" prop="estimateWorkHour" :label-width="formLabelWidth">
          <el-input style="width: 90%;" type="number" v-model="form.estimateWorkHour" @change="handleEdit" placeholder="小时" :disabled="isProjectDisabled">时</el-input>
          <el-tooltip class="item" effect="light" placement="top">
            <div slot="content">
              <span>一天6工时，最多30工时</span>
            </div>
            <i class="el-icon-question" style="color: #409EFF;"></i>
          </el-tooltip>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="计划完成日期" prop="planFinishDate" :label-width="formLabelWidth">
          <el-date-picker :disabled="isProjectDisabled" value-format="yyyy-MM-dd"
                          v-model="form.planFinishDate" type="date" placeholder="请选择日期" />
        </el-form-item>
        <el-form-item  label="创建人" prop="creatorId" :label-width="formLabelWidth">
          <el-select :style="iptStyle"   filterable collapse-tags  size="mini"  :disabled="isProjectDisabledEdit" v-model="form.creatorId"   placeholder="请选择创建人">
            <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
      </div>
      <div v-if="isUpdata" style="display: flex;">
        <el-form-item label="状态" prop="status_desc" :label-width="formLabelWidth">
          {{form.status_desc}}
        </el-form-item>
        <!--        <el-form-item label="创建人" prop="creator" :label-width="formLabelWidth">
                    <span>
                      {{form.creator.nameZh ? form.creator.nameZh: ''}}
                      {{form.creator.nameEn ? '('+form.creator.nameEn + ')': ''}}
                     </span>
                </el-form-item>-->
        <el-form-item label="创建时间" prop="createTime" :label-width="formLabelWidth">
          {{form.createTime}}
        </el-form-item>
      </div>
      <el-form :model="pDevForm" :rules="pDevRules" ref="pDevForm" v-if="(isUpdata && form.status_id > 1) || isUpdata && form.status_id === 1 && isOwner " >
        <el-form-item v-if="isUpdata" prop="operatorContext" :label="showTitle"   :label-width="formLabelWidth" >
          <EditorOther v-if="!loading.dialog"  :content="pDevForm.operatorContext"  @contentData="changeOperatorContent"/>
        </el-form-item>
      </el-form>
      <el-form-item v-if="form.id && historylist.length" label="任务历史" :label-width="formLabelWidth">
        <TaskHistory :list="historylist" />
      </el-form-item>
      <el-form :model="form" v-if="isUpdata">
        <el-form-item class="comment_warp" label="评论" :model="form" :label-width="formLabelWidth">
          <Comment  :id="form.id" :busiId="form.id"  type="6"/>
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="isUpdata && step != 2 && form.status_id !==3 && isCreator" type="warning" @click="changeStep(2)">编 辑</el-button>
      <el-button v-show="isCreate" type="warning" :loading="loading.submit" @click="onSubmit">创建</el-button>
      <el-button v-show="isUpdata && step == 2 && isCreator" type="warning" :loading="loading.submit" @click="onSubmit(true,'operatorContext')">保存</el-button>
      <el-button v-show="isUpdata && form.status_id === 0 && isOwner && step != 2" type="warning" :loading="loading.submit" @click="SubmitAction(1)">开始处理</el-button>
      <el-button v-show="isUpdata && form.status_id === 1 && isOwner && step == 1" type="warning" :loading="loading.submit" @click="onSubmit(true,'operatorContext')">保存</el-button>
      <el-button v-show="isUpdata && form.status_id === 1 && isOwner && step != 2" type="warning" :loading="loading.submit" @click="DevSUbmitOtherTask(2)">提交处理</el-button>
      <el-button v-show="isUpdata && form.status_id === 2 && isCreator && step != 2" type="warning" :loading="loading.submit" @click="SubmitAction(3)">验收通过</el-button>
      <el-button v-show="isUpdata && form.status_id === 2 && isCreator && step != 2" type="warning" :loading="loading.submit" @click="SubmitAction(4)">验收驳回</el-button>
      <el-button v-show="isUpdata && (form.status_id === 0 || form.status_id === 1) && isCreator && step != 2" type="danger" :loading="loading.submit" @click="cancelTask()">取消</el-button>
      <el-button v-show="isUpdata  && isCreator && step != 2" type="warning" :loading="loading.submit" @click="copyTask()">一键复制</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <el-dialog center :append-to-body="true" title="延期原因" :visible.sync="dialogVisibleDelay" width="40%">
      <el-form :model="pSubmitForm" :rules="pSubmitRules" ref="pSubmitForm">
        <el-form-item label="延期类型" prop="reasonCode" :label-width="formLabelWidth" >
          <el-select v-model="pSubmitForm.reasonCode" placeholder="请选择" >
            <el-option v-for="(key, val) in typeList" :key="key" :label="key" :value="val" />
          </el-select>
        </el-form-item>
        <el-form-item label="原因" prop="reasonDetail" :label-width="formLabelWidth" >
          <el-input type="textarea" rows="3" v-model="pSubmitForm.reasonDetail" autocomplete="off" placeholder="延期原因" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary" :loading="loading.submitDelay" @click="onSubmitDelay">确 定</el-button>
          <el-button size="small" @click="dialogVisibleDelay = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Editor,EditorOther } from "@/components/index.js";
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import { formatEnToUtf8, formatTimeToDate } from "@/views/tops/devOps/components/util.js";
import {
  postDevOpsSpaceCreateOtherTaskApi,
  getDevOpsSpaceOtherDetailApi,
  postDevOpsSpaceUpdateOtherTaskApi,
  postDevOpsSpaceSUbmitOtherTaskApi,
  getDevOpsSpaceDelayReasonListApi,
  postDevOpsSpaceSUbmitDelayReasonApi, getDevOpsSpaceHistoryTaskListApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {TaskHistory} from "@/views/tops/devOps/components/list";
export default {
  components: {TaskHistory, Comment, Editor, EditorOther },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    workId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: {
        priority: 'P1',
        plt: '',
        is_admin: false,
        plet: '',
        title: '',
        context:'',
        type:'',
        leading:'',
        showTitle: '负责人做了啥',
        creatorId: '',
      },
      pDevForm:{
        operatorContext: '',
      },
      rules: {
        title: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        context: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        projectSystemId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        ownerId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        demanderId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        priority: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        estimateWorkHour: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate: {
          // required: true,
          message: "必填",
          trigger: "blur",
        },
        creatorId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      pDevRules: {
        operatorContext: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      pSubmitForm:{
        reasonCode:'',
        reasonDetail: '',
      },
      pSubmitRules:{
        reasonCode: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reasonDetail: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
        submitDelay: false,
      },
      dialogVisibleTask: false,
      step: 1,
      formTaskInfo: {},
      showDetails: false,
      // 判断是否是产品
      isUserPm:false,
      userId: '',
      username: '',
      dialogVisibleDelay: false,
      typeList: {},
      historylist: [],
    };
  },
  async mounted() {
    const { id = '', status = '', task_type = '' , context = '' , demander = '' , leading = '' , plet = '' , plt = this.getDate() , priority = '' , project_system = '' , create_time= '' ,username : creator, title ='',orderTitle='',orderDesc='',orderCreator='',openType =''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, id, status, task_type, context, demander, leading, plet, plt, priority,  project_system, create_time, creator ,title,openType}
    this.$set(this.form, 'username', username)
    this.username = username;
    if (this.isUpdata) {
      await this.init(id);
      await this.getHistoryList();
    } else {
      if(id && openType === 'copy'){
        await this.init(id);
        this.form.planFinishDate = '';
      }
      this.step = 2;
      this.$set(this.form, 'user_pm', username)
      if(this.allUserList.DEVUSERUSER[username]){
        let defauleUserId = this.allUserList.DEVUSERUSER[username];
        this.form.creatorId = defauleUserId.toString();
      }
    }
    if(this.allUserList.ALLUSERIDLIST1[username]){
      this.userId = this.allUserList.ALLUSERIDLIST1[username];
    }
    if(orderTitle) this.form.title = orderTitle;
    if(orderDesc) this.form.context = orderDesc;
    if(orderCreator) this.form.demanderId = orderCreator.toString();

  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          NEWOTHERTYPE: (state) => state.devOps.NEWOTHERTYPE,
        }
    ),
    newTitle() {
      if (this.isUpdata) {
        return '其他任务-' + this.form.title;
      } else {
        if(this.formInfo.openType === 'copy') return '新增其他任务类型-复制';
        return '新增其他任务类型'
      }
    },
    // 判断是否是新建
    isUpdata() {
      return this.form.id && this.form.openType !== 'copy';
    },
    isCreate(){
      const { id = '', openType = '' } = this.formInfo;
      return !id || openType === 'copy';
    },
    // 部分不可编辑
    isProjectDisabled() {
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
      }
      return false; // 默认可编辑
    },
    // 部分不可编辑
    isProjectDisabledEdit() {
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 2) return false;
      }
      return true; // 默认可编辑
    },
    isCreator(){
      if(this.isAdmin || this.isCreatorLeader) return true;
      if(this.form.creator){
        return this.form.creator.nameEn === this.form.username;
      }
      return false;
    },
    isOwner(){
      if(this.isAdmin || this.isOwnerLeader) return true;
      if(this.form.owner){
        return this.form.owner.nameEn === this.form.username;
      }
      return false;

    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isCreatorLeader(){
      if(this.userId && this.form.creator){
        const creatorId = this.form.creator.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[creatorId]){
          return this.allUserList.LEADERUSER[creatorId] === this.userId;
        }
      }
      return false;
    },
    isOwnerLeader(){
      if(this.userId && this.form.owner){
        const ownerId = this.form.owner.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[ownerId]){
          return this.allUserList.LEADERUSER[ownerId] === this.userId;
        }
      }
      return false;
    },
  },
  methods: {
    getDate() {
      var now = new Date().getTime();
      return now;
    },
    changeStep() {
      this.step = 2;
    },
    // 获取需求详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceOtherDetailApi({ id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          type:info.type.toString(),
          ownerId: info.owner_id.toString(),
          projectSystemId: info.projectSystemId.toString(),
          demanderId: info.demander_id.toString(),
          creatorId: info.creator.id ? info.creator.id.toString(): '',
        };
        this.pDevForm.operatorContext = info.operatorContext;
        if(this.isOwner){
          this.showTitle = '我做了啥';
        }
        await this.DelayReasonList();
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:6,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    async DelayReasonList() {
      await getDevOpsSpaceDelayReasonListApi({type: 3}).then((ret) => {
        let arr = {};
        ret.data.forEach((item) => {
          arr[item.reasonCode] = item.reasonDesc;
        })
        this.typeList = arr;
      });
    },
    // 提交
    async onSubmit(close = true,type = '') {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close,type)
        }
      });
    },
    // 调用提交接口
    async moduleSubmit(close = true,type){
      try {
        close && this.$set(this.loading, 'submit', true)
        let params = {
          ...this.form,
          type: Number(this.form.type),
          demanderId: Number(this.form.demanderId),
          ownerId: Number(this.form.ownerId),
          estimateWorkHour: Number(this.form.estimateWorkHour),
          creatorId: Number(this.form.creatorId),
        };
        if(this.isUpdata && this.pDevForm.operatorContext && type === 'operatorContext'){
          params.operatorContext = this.pDevForm.operatorContext;
        }
        // id 存在 更新 不存在 创建
        const ret = this.isUpdata ? await postDevOpsSpaceUpdateOtherTaskApi(params) : await postDevOpsSpaceCreateOtherTaskApi({...params,work_id:this.workId});
        if (ret.status === 'success') {
          if (close) {
            this.$notify({
              message: '提交成功',
              type: "success",
            })
            setTimeout(() => {
              if(this.form.reviewed_status === 'under_review') {
                this.handleClose('demand')
              }else{
                this.handleClose()
              }
            }, 500)
          }
        } else {
          this.$notify({
            message: ret?.data?.msg || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    DevSUbmitOtherTask(type){
      let currentTime = Date.parse(this.getNowDate());
      let planFinishDate = Date.parse(this.form.planFinishDate);
      if(currentTime > planFinishDate){
        this.dialogVisibleDelay = true;
      }else{
        this.$refs["pDevForm"].validate(async (valid) => {
          if (valid) {
            this.SubmitAction(type)
          }
        })
      }
    },
    //提交延期原因
    onSubmitDelay(){
      this.$refs["pSubmitForm"].validate(async (valid) => {
        if (valid) {
          this.$set(this.loading, 'submitDelay', true);
          postDevOpsSpaceSUbmitDelayReasonApi({taskId: Number(this.form.id),reasonCode: Number(this.pSubmitForm.reasonCode),reasonDetail: this.pSubmitForm.reasonDetail,type: 3,is_delay:1}).then((ret)=>{
            if(ret.status === 'success'){
              this.SubmitAction(2);
            }else{
              this.$notify({
                message: ret.message ||"提交失败",
                type: "error",
              })
            }
            this.loading.submitDelay = false;
          });
        }
      })
    },
    SubmitAction(type){
      let params = {
        id: this.form.id,
        type: type
      };
      if(type === 2){
        params = {...params,...this.pDevForm}
      }
      postDevOpsSpaceSUbmitOtherTaskApi(params).then((res)=>{
        if (res.status === 'success') {
          this.$notify({
            message: res.message || "保存成功",
            type: "success",
          })
          setTimeout(() => {
            this.handleClose()
          }, 500)
        }else{
          this.$notify({
            message: res.message || "失败",
            type: "error",
          })
        }
      });
    },
    //取消任务
    cancelTask(){
      this.$confirm("确认取消该任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.SubmitAction(5)
      })

    },
    // 关闭弹窗
    handleClose() {
      this.hideDialogVisible()
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.context = val;
    },
    changeOperatorContent(val){
      this.pDevForm.operatorContext = val;
    },
    //预估工时只能正整数
    handleEdit(e) {
      let value = e.replace(/^(0+)|[^\d]+/g,''); // 以0开头或者输入非数字，会被替换成空
      value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
      if(value > 30){
        value = 30;
      }
      this.form.estimateWorkHour = Number(value)
    },
    copyTask(){
      this.hideDialogVisible();
      setTimeout(() => {
        let data = this.form;
        data.openType = 'copy';
        this.showDialogVisible('create',data);
      }, 500)

    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
    formatTimeToDate,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}

.popperDom {
  max-width: 240px;
}
</style>
